import { Component, OnInit, Output, EventEmitter, Input, OnDestroy } from '@angular/core';
import { PrenoteHistoryFilters } from './prenote-history-filters.model';
import { map, takeUntil } from 'rxjs/operators';
import { PrenoteHistoryFiltersService } from './prenote-history-filters.service';
import { sortBy } from 'lodash';
import { BaseObserver } from '../../../../shared/baseobserver';
import { Subscription } from 'rxjs';
import { CompanyBasicInfo } from '../../../../services/company.model';
import { CompanyService } from '../../../../services/company.service';
import { SettingsService } from '../../../../shared/services/settings/settings.service';

@Component({
  selector: 'ssg-prenote-history-filters',
  templateUrl: './prenote-history-filters.component.html',
  styleUrls: ['./prenote-history-filters.component.less']
})
export class PrenoteHistoryFiltersComponent extends BaseObserver implements OnInit, OnDestroy {
  @Output() toggle: EventEmitter<boolean>;
  private _lastFilters: PrenoteHistoryFilters;
  private _subscriptions: Subscription[];
  editFilters: PrenoteHistoryFilters;
  companiesDataSource: CompanyBasicInfo[] = [];

  @Input() isWorking: boolean;

  constructor(private readonly _companyService: CompanyService,
    private readonly _filtersService: PrenoteHistoryFiltersService,
    private readonly _settings: SettingsService) {

    super();
    this.toggle = new EventEmitter<boolean>();
  }

  ngOnInit() {
    this.getCompaniesDataSource();

    this._lastFilters = null;
    this._subscriptions = [];

    this._subscriptions.push(this._filtersService.getFilters().subscribe(filters => this._handleFiltersUpdated(filters)));
  }

  ngOnDestroy() {
    if (this._subscriptions) {
      for (const subscription of this._subscriptions) {
        subscription.unsubscribe();
      }

      this._subscriptions = null;
    }
  }

  applyEdits() {
    if (this.isWorking) {
      return;
    }

    this._filtersService.updateFilters(this.editFilters);
  }

  clearEditFilters() {
    this.editFilters.reset();
    this.applyEdits();
  }

  toggleFilters(value: boolean) {
    this.toggle.emit(value);
  }

  private getCompaniesDataSource(): void {
    this._companyService.getCompanyBasicInfos(this._settings.tenantId, 1, 10)
      .pipe(
        map(companies => sortBy(companies, ['legalName'])),
        takeUntil(this.destroy$)
      )
      .subscribe(result => {
          this.companiesDataSource = result;
        });
  }

  private _handleFiltersUpdated(filters: PrenoteHistoryFilters) {
    if (this._lastFilters !== null &&
      PrenoteHistoryFilters.areEqual(this._lastFilters, filters)) {

      return;
    }

    this.editFilters = filters.clone();
    this._lastFilters = filters;
  }

  searchCompaniesByLegalName(e) {
    const text = e.term;
    this._companyService.getCompanyBasicInfos(this._settings.tenantId, 1, 10, text)
      .pipe(
        map(companies => sortBy(companies, ['legalName'])),
        takeUntil(this.destroy$)
      )
      .subscribe(result => {
          this.companiesDataSource = result;
        });
  }
}
